module.exports = __webpack_public_path__ + "img/07.f1f90057.jpg";